module.exports = "\r\n<my-app-sidenav></my-app-sidenav>\r\n<section id=\"page-container\" class=\"app-page-container\">\r\n    <my-app-header></my-app-header>\r\n    <div class=\"app-content-wrapper\">\r\n        <div class=\"app-content\">\r\n            <div class=\"full-height\">\r\n                <router-outlet></router-outlet>\r\n            </div>\r\n        </div>\r\n        <my-app-footer></my-app-footer>\r\n    </div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/main.component.html
// module id = 1036
// module chunks = 1